export default __webpack_public_path__ + "assets/fonts/MYRIADPRO-BOLDCOND.OTF";